var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
      !_vm.page.page_content['slot-classes'] ||
      _vm.page.page_content['slot-classes'].length < 1
    )?[_vm._v("\n    500 Internal Server Error\n  ")]:_vm._l((_vm.page.page_content['slot-classes']),function(parent,indexParent){return _c('RecursiveLevelSlot',{key:indexParent,attrs:{"node":_vm.ExtraLevelTreeBySlot[parent['slot-name']]}},_vm._l((parent.page_sections
          ? parent.page_sections
          : []),function(page_section,indexContent){return _c('RecursiveLevelSection',{key:indexContent,attrs:{"node":_vm.LevelTreeBySection[page_section.page_section_id],"languageCodeList":_vm.languageCodeList,"isClientPage":_vm.isClientPage}})}),1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }